function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 7.915a6.915 6.915 0 1113.83 0 6.915 6.915 0 01-13.83 0zm9.83-1.589a.482.482 0 10-.683-.682L7.272 8.52l-.946-.945a.482.482 0 00-.682.682l1.287 1.287a.482.482 0 00.682 0l3.216-3.217z",
  fill: "#0063E3"
});

var SvgCheckCircleFilled = function SvgCheckCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default SvgCheckCircleFilled;